// src/components/Dashboard/DashboardErrorBoundary.tsx
import React from 'react';

interface DashboardErrorBoundaryProps {
  children: React.ReactNode;
}

interface DashboardErrorBoundaryState {
  hasError: boolean;
  errorMsg: string | null;
}

export class DashboardErrorBoundary extends React.Component<
  DashboardErrorBoundaryProps,
  DashboardErrorBoundaryState
> {
  constructor(props: DashboardErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      errorMsg: null,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorMsg: error.message };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center">
          <h2 className="text-red-600 text-lg font-medium mb-4">
            Error loading data
          </h2>
          <p className="text-sm text-gray-700">{this.state.errorMsg}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 mt-4 bg-blue-500 text-white rounded"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
